import React, { useEffect, useState } from "react";
import "./documents.scss";
import { message, Row, Card, Space, Typography, Col, Button, Flex, Form, Popconfirm, List, Divider } from "antd";
import { menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import DocumentsServices from "../../services/documentsServices";
import { Link, useParams } from "react-router-dom";
import { FilePdfOutlined, PlusOutlined, DeleteOutlined, DownloadOutlined, FolderAddOutlined, LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from "file-saver";
import TextArea from "antd/es/input/TextArea";
import AddDocumentAttachment from "./newDocumentAttachmentModal.js";
import { useCurrentUserContext } from "../../context/currentUserContext.js";
import ReplaceDocumentPdfModal from "./replaceDocumentPdfModal.js";
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import LavorazioneModal from "./lavorazioneModal.js";
import { PageHeader } from "../../components/common/pageHeader.js";
import ContentLoader from "../../components/common/contentLoader.js";
import DocumentAnomaliesHistory from "./documentAnmomaliesHistory.js";
import { handleAnomalyDateConvertDayJs } from "../../utils/functions.js";
import { group2Rights, isSuperAdmin } from "../../configs/auth/roleRights.js";
import DocumentNotes from "../sharedComponents/documentNotes.js";

const { Text } = Typography;

const ViewDocument = () => {
  const urlParams = useParams();
  const anomaliesList = useSelector(state => state.anomalies.anomalies);
  const [documentData, setdocumentData] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [documentAttachment, setDocumentAttachments] = useState("");
  const [documentNotesFromParent, setDocumentNotesFromParent] = useState([]);
  const { currentUser } = useCurrentUserContext();
  const [loadingReplaceDocumentPdf, setLoadingReplaceDocumentPdf] = useState(false);
  const [loadingRegisterDocument, setLoadingRegisterDocument] = useState(false);
  const [showDocumentReplacementModal, setShowDocumentReplacementModal] = useState(false);
  const [showLavorazioneModal, setShowLavorazioneModal] = useState(false);
  const [loadingAttachmentList, setLoadingAttachmentList] = useState(false);
  const [loadingRemoveAttachment, setLoadingAttachmentDelete] = useState(false);
  const [anomaliesHistory, setAnomaliesHistory] = useState(null);
  const [anomaliesHistoryDrawer, setAnomaliesHistoryDrawer] = useState(false);
  const [loadingExportLogs, setLoadingExportLogs] = useState(false);
  const [loadingSospesoDocument, setLoadingSospesoDocument] = useState(false);


  useEffect(() => {
    getDocumentDataByID(urlParams.id, currentUser.id);
    getDocumentAttachmentList(urlParams.id);
  }, []);

  const getDocumentDataByID = async (documentId, userId) => {
    setLoadingButton(true);
    setLoadingData(true);
    try {
      const respData = await DocumentsServices.getDocument(documentId, userId);
      if (respData.success) {
        let result = respData.responseObject.value.document;
        setdocumentData(result);
        setAnomaliesHistory(result.documentAnomalyHistory)
        setLoadingButton(false);
        setLoadingData(false);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingButton(false);
        setLoadingData(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingButton(false);
      setLoadingData(false);
    }
  };

  const handelModalClose = () => {
    setShowAttachmentModal(false);
    setShowDocumentReplacementModal(false);
  };

  const toggleUploadAttachmentModal = () => {
    setShowAttachmentModal(true);
  };

  function toggleDocumentReplacementModal() {
    setShowDocumentReplacementModal(true);
  };

  function toggleLavorazioneModal() {
    setShowLavorazioneModal(true);
  };

  const onDocumentPdfView = async (documentId) => {
    message.warning(notifyMessages.generateDocumentPdfLoading);
    try {
      const respData = await DocumentsServices.readDocumentPDF(documentId);

      if (respData.success) {
        let pdfData = respData.responseObject.value;
        if (pdfData.documentPdfURI) {
          // handle and convert base64 to PDF
          let base64str = pdfData.pdfArray;
          let binary = atob(base64str.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);

          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          let blob = new Blob([view], { type: "application/pdf" });
          let url = URL.createObjectURL(blob);
          window.open(url, "Document", "width=800,height=600");
        } else {
          message.error(notifyMessages.noFileFound);
        }
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const getDocumentAttachmentList = async (documentId) => {
    //setLoadingButton(true);
    setLoadingAttachmentList(true);
    try {
      const respData = await DocumentsServices.getDocumentAttachments(
        documentId
      );
      if (respData.success) {
        let result = respData.responseObject.value.attachmentList;
        setDocumentAttachments(result.filter(doc => !doc.isInvoicePDF));
        setLoadingAttachmentList(false);
      } else {
        //setLoadingButton(false);
        setLoadingAttachmentList(false);
      }
    } catch (error) {
      //setLoadingButton(false);
      setLoadingAttachmentList(false);
    }
  };

  const createExportLogsFile = () => {
    let formatedLogsData = [];

    if (documentNotesFromParent && documentNotesFromParent.length > 0) {
      setLoadingExportLogs(true);

      documentNotesFromParent.map(item => {
        formatedLogsData.push({
          Data: item.operationDate ? moment(item.operationDate).format("DD/MM/YYYY") : "",
          Messaggio: item.description,
          Utente: item.userName ? `${item.userName}${item.roleName ? ` (${item.roleName})` : ""}` : "",
          Manutentore: item.supplierName
            ? `${item.supplierName}${item.supplierVatCode ? ` - (${item.supplierVatCode})` : ""}`
            : ""
        });
      });

      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const fileName = `ESPORTAZIONE-LOGs-confartigianato-portale-${moment().format("DD/MM/YYYY")}`;

      const headers = [["Data", "Messaggio", "Utente", "Manutentore"]];
      const ws = XLSX.utils.json_to_sheet([]);


      XLSX.utils.sheet_add_json(ws, formatedLogsData, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_aoa(ws, headers);


      const noteRowStart = documentNotesFromParent.length + 1;

      // Add the "Note" label in column D, one row below the ata
      XLSX.utils.sheet_add_aoa(ws, [["", "", "", "Note"]], { origin: `A${noteRowStart + 1}` });
      // Add the actual note value from documentData.notes in the row below the "Note" label
      XLSX.utils.sheet_add_aoa(ws, [["", "", "", documentData?.notes || ""]], { origin: `A${noteRowStart + 2}` });
      // Make the "Note" label bold
      const noteLabelCell = XLSX.utils.encode_cell({ c: 3, r: noteRowStart });
      if (ws[noteLabelCell]) {
        ws[noteLabelCell].s = {
          font: { bold: true }
        };
      }
      // Column widths
      ws["!cols"] = Array(25).fill({ wpx: 120 });

      // Bold headers
      for (let key in ws) {
        if (typeof ws[key] !== "object") continue;
        let cell = XLSX.utils.decode_cell(key);
        if (cell.r === 1) {
          let p = key.replace("2", "1");
          ws[p].s = { font: { bold: true } };
        }
      }

      const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const dataBlob = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataBlob, fileName + fileExtension);
      setLoadingExportLogs(false);
    }
  };


  const handelSaveAttachment = async (file) => {
    const formData = new FormData();
    formData.append("files", file.files);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", false);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);
    setLoadingButton(true);
    try {
      const respData = await DocumentsServices.addDocumentAttachment(formData);

      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingButton(false);
        handelModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingButton(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingButton(false);
    }
  };

  const onDocumentPdfReplace = async (file) => {
    const formData = new FormData();
    formData.append("files", file.file.file);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", true);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);
    setLoadingReplaceDocumentPdf(true);
    try {
      const respData = await DocumentsServices.addDocumentAttachment(formData);
      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingReplaceDocumentPdf(false);
        handelModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingReplaceDocumentPdf(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingReplaceDocumentPdf(false);
    }
  };

  const onAttachmentRemove = async (attachmentId) => {
    setLoadingAttachmentDelete(true);
    try {
      const respData = await DocumentsServices.removeDocumentAtachment(attachmentId, currentUser.id);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        setLoadingAttachmentDelete(false);
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingAttachmentDelete(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingAttachmentDelete(false);
    }
  };

  const handelLavorazioneModalClose = () => {
    setShowLavorazioneModal(false);
    getDocumentDataByID(urlParams.id, currentUser.id);
  }

  const registerDocument = async (anomalyId) => {
    setLoadingRegisterDocument(true);
    const payload = {
      documentID: urlParams.id,
      userID: currentUser.id,
      anomalyID: anomalyId
    };
    try {
      const resp = await DocumentsServices.registerDocument(payload);
      if (resp.success) {
        message.success(notifyMessages.operationSuccess);
        setLoadingRegisterDocument(false);
        handelLavorazioneModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingRegisterDocument(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingRegisterDocument(false);
    }
  };

  const onDocumentSospeso = async (anomalyId) => {
    const payload = {
      documentID: documentData.id,
      userID: currentUser.id,
      anomalyID: anomalyId
    };
    setLoadingSospesoDocument(true);
    try {
      const respData = await DocumentsServices.documentInSospeso(payload);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        handelLavorazioneModalClose();
      }
      else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    } finally {
      setLoadingSospesoDocument(false);
    }
  }

  const setNonDiCommpetenza = async () => {
    const payload = {
      documentID: documentData.id,
      userID: currentUser.id
    };

    try {
      const respData = await DocumentsServices.handelNonCompetenza(payload);

      if (respData.success) {
        message.success(notifyMessages.success);
        handelLavorazioneModalClose();
      }
      else {
        message.error(notifyMessages.errorAccured);
      }

    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  }

  const setDocNotesToParent = (notes) => {
    setDocumentNotesFromParent(notes);
  }

  return (
    <div className="document-details">
      <PageHeader title="Visualizzazione documento" />

      {!documentData && <ContentLoader />}

      {documentData && (
        <>
          {showAttachmentModal && (
            <AddDocumentAttachment
              showAttachmentModal={showAttachmentModal}
              handelModalClose={handelModalClose}
              handelSaveAttachment={handelSaveAttachment}
              loadingButton={loadingButton}
              documentData={documentData}
            />
          )}

          {showDocumentReplacementModal &&
            <ReplaceDocumentPdfModal
              showDocumentReplacementModal={showDocumentReplacementModal}
              handelModalClose={handelModalClose}
              onDocumentPdfReplace={onDocumentPdfReplace}
              documentData={documentData}
              loadingReplaceDocumentPdf={loadingReplaceDocumentPdf}
            />
          }

          {showLavorazioneModal &&
            <LavorazioneModal
              showLavorazioneModal={showLavorazioneModal}
              handelModalClose={handelLavorazioneModalClose}
              documentData={documentData}
              anomalies={anomaliesList}
              registerDocument={registerDocument}
              loadingRegisterDocument={loadingRegisterDocument}
              loadingSospesoDocument={loadingSospesoDocument}
              onDocumentSospeso={onDocumentSospeso}
              setNonCompetenza={setNonDiCommpetenza}
            />
          }


          {anomaliesHistory && (
            <DocumentAnomaliesHistory open={anomaliesHistoryDrawer} onClose={() => setAnomaliesHistoryDrawer(false)} anomalies={anomaliesHistory} />
          )}


          {/* <Card className="docDetailsCard"> */}
          <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="default"> <Link to={{ pathname: menuLinks.raportiControllo }}> Lista Documenti </Link> </Button>
                  {group2Rights(currentUser) && (
                    <>
                      <Button type="default"> <Link to={{ pathname: `${menuLinks.raportiControllo}/id/${urlParams.id}` }}> Modifica Documento </Link> </Button>
                      <Button type="primary" onClick={() => toggleLavorazioneModal()}> Lavorazione </Button>
                    </>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <Row gutter={{ lg: 24 }} className="mt10">
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                  <Card size="small" className="infoCardv1" title="Dati documento" >
                    <Space direction="vertical" className="docData">
                      <span>  <Text strong> Tipo: </Text>  <Text>{documentData.typeName} </Text> </span>
                      <span> <Text strong> Targa Impianto: </Text> <Text> {documentData.plate} </Text> </span>
                      <span> <Text strong> Anno: </Text> <Text> {documentData.year}</Text> </span>
                      <span> <Text strong> Batch: </Text> <Text> {documentData.flux}</Text> </span>
                      <span> <Text strong> Data Caricamento: </Text> <Text> {documentData.dateAdded ? moment(documentData.dateAdded).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Data Modifica: </Text> <Text> {documentData.lastUpdatedDate ? moment(documentData.lastUpdatedDate).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Utente: </Text> <Text> {documentData.lastEditedUserName}</Text> </span>
                    </Space>
                  </Card>
                </Col>

                <Col
                  className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
                  <Card size="small" className="infoCardv1" title="Stato documento">
                    <Space direction="vertical" className="docData">
                      <span> <Text strong> Anomalie: </Text>
                        <Text style={{ color: "#c11919", fontSize: "13px", fontWeight: 500 }}> {(anomaliesHistory && anomaliesHistory.length > 0) ? `${"• [" + handleAnomalyDateConvertDayJs(anomaliesHistory[0].operationDate) + "] "} ${anomaliesHistory[0].anomalyName}` : ""} </Text>
                        {anomaliesHistory && anomaliesHistory.length > 0 && (
                          <Text italic style={{ fontSize: 12, color: "#2485b5", marginLeft: 20 }} onClick={() => setAnomaliesHistoryDrawer(true)}> [...vedi piu] </Text>
                        )}
                      </span>

                      <span> <Text strong> Stato lavoraz: </Text> <Text> {documentData.workingStatusName} </Text> </span>
                      <span> <Text strong> Operatore: </Text> <Text> {documentData.operatorName} </Text> </span>
                      <span> <Text strong> Data registrazione: </Text> <Text> {documentData.registrationDate ? moment(documentData.registrationDate).format("DD/MM/YYYY") : ""} </Text></span>
                    </Space>
                  </Card>
                </Col>
              </Row>

            </Col>
          </Row>


          <Row gutter={{ lg: 24 }} className="mt10">

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="primary" onClick={() => onDocumentPdfView(documentData.id)}> Anteprima/Scarica </Button>
                  <Button type="primary" disabled={(documentNotesFromParent && documentNotesFromParent.length > 0) ? false : true} loading={loadingExportLogs} onClick={createExportLogsFile}> Esporta logs </Button>

                  {group2Rights(currentUser) && (
                    <Button type="primary" onClick={() => toggleDocumentReplacementModal()} icon={<FilePdfOutlined />}> Sostituisci PDF </Button>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              {/* <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                  <Flex gap="small" wrap>
                    <Button type="primary" onClick={() => onDocumentPdfView(documentData.id)}> Anteprima/Scarica </Button>
                    <Button type="primary"> Esporta logs </Button>
                    <Button type="primary" onClick={() => toggleDocumentReplacementModal()} icon={<FilePdfOutlined />}> Sostituisci PDF </Button>
                  </Flex>
                </div> */}


              <Card size="small" className="infoCardv2" title="Note" >
                <DocumentNotes documentId={documentData.id} getDocumentDataByID={() => getDocumentDataByID} setDocNotesToParent={setDocNotesToParent} />
              </Card>

            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              <Card size="small" className="infoCardv3" title="Altri dati" >
                <Space direction="vertical" className="docAltriData">
                  <span> <Text strong> Divisione: </Text> <Text> {documentData.divisionName} </Text> </span>
                  <span> <Text strong> Note: </Text> <Text> {documentData.notes} </Text> </span>
                  <span> <Text strong> Ragione Sociale manutentore: </Text> <Text> {documentData.supplierName} </Text> </span>
                  <span> <Text strong> Partita IVA manutentore: </Text> <Text> {documentData.supplierVatCode} </Text> </span>
                  <span>  <Text strong> Utente: </Text> <Text> {documentData.lastEditedUserName} </Text> </span>
                  <span>  <Text strong> Data ultima modifica: </Text>  <Text> {documentData.lastUpdatedDate ? moment(documentData.lastUpdatedDate).format("DD/MM/YYYY") : ""}</Text></span>
                </Space>
              </Card>

              <div className="mt15">
                <Card size="small" className="infoCardv3 attachments"

                  // title="Attachments" 
                  title={
                    <Space direction="horizontal">
                      <Text>Allegati a questo documento</Text>
                      <>
                        {loadingRemoveAttachment ? <LoadingOutlined /> : ""}
                        <Button
                          onClick={() => toggleUploadAttachmentModal()}
                          size="small"
                          type="primary"
                          shape="circle"
                          icon={<FolderAddOutlined />}
                        />
                      </>
                    </Space>
                  }
                >
                  {loadingAttachmentList ? (
                    <ContentLoader />  // Show the loader when the list is loading
                  ) : (
                    <Space direction="vertical" style={{ width: "100%" }}>
                      {documentAttachment &&
                        documentAttachment.map((item, index) => (
                          <span key={item.id}>
                            <Text className="mr10" strong> {item.attachmentName} </Text>
                            <Button key={item.id + index} className="mr10" size="small" shape="circle" href={item.pathName} icon={<DownloadOutlined />} />

                            {isSuperAdmin(currentUser) && (
                              <Popconfirm
                                title={"Rimuovi questo Attachment?"}
                                onConfirm={() => onAttachmentRemove(item.id)}
                                okText={"Si"}
                                cancelText={"No"}
                              >
                                <Button key={index} size="small" shape="circle" icon={<DeleteOutlined />} />
                              </Popconfirm>
                            )}
                            <Divider style={{ margin: "10px" }} />

                          </span>
                        ))}
                    </Space>
                  )}
                </Card>
              </div>
            </Col>
          </Row>
          {/* </Card> */}
        </>
      )}
    </div>
  );
};

export default ViewDocument;
